import { ENV } from '@acorns/web-utils'

const TOGGLES_ENV_INDEX_OVERRIDE_STORAGE_KEY =
  'acorns_toggles_env_index_override'

export function getTogglesEnvIndex(): number {
  const togglesEnvIndex = parseInt(
    process.env.AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEYS_INDEX!,
    10,
  )

  if (process.env.BUILD_ENV === ENV.Production) {
    return togglesEnvIndex
  }

  const togglesEnvIndexOverride = window.sessionStorage.getItem(
    TOGGLES_ENV_INDEX_OVERRIDE_STORAGE_KEY,
  )

  return togglesEnvIndexOverride
    ? parseInt(togglesEnvIndexOverride, 10)
    : togglesEnvIndex
}

export function setTogglesEnvIndexOverride(indexOverride: number) {
  window.sessionStorage.setItem(
    TOGGLES_ENV_INDEX_OVERRIDE_STORAGE_KEY,
    indexOverride.toString(),
  )
}
